<template>
    <div>
        <h5 class="title is-5">P.O. Request By Client & Date Range</h5>
        <div class="columns">
            <div class="column is-3">
                <div class="field">
                    <label class="label is-small">Clients</label>
                    <div class="control">
                        <b-autocomplete v-model="clientName" size="is-small" :data="clients" placeholder="Search clients" @select="option => selectedClient = option" @input="searchClients" :loading="isFetchingClients">
                            <template slot="empty">
                                <span v-if="isFetchingClients">
                                    Please wait...
                                </span>
                                <span v-if="clients.length === 0">
                                    No results found
                                </span>
                            </template>
                        </b-autocomplete>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Date from</label>
                    <div class="control">
                        <input type="date" v-model="poRequestByClientDateRange.dateFrom" class="input is-small" />
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Date to</label>
                    <div class="control">
                        <input type="date" v-model="poRequestByClientDateRange.dateTo" class="input is-small" />
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">&nbsp;</label>
                    <div class="control">
                        <b-button type="is-small" :loading="isFetching" @click="downloadPdf">Download PDF</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import AppToast from '../frontend/appToast'

const appToast = new AppToast()

export default {
  data: () => ({
    // search clients
    clientName: '',
    clients: [],
    selectedClient: 0,
    isFetchingClients: false,

    poRequestByClientDateRange: {},
    isFetching: false
  }),
  methods: {
    searchClients() {
      // authService.isLoggedIn() // check login
      axios
        .get(`api/searchqueries/clients-by-name/${this.clientName}/false`)
        .then(response => {
          this.clients = response.data
        })
        .catch(error => console.log(error.response))
    },
    downloadPdf() {
      if (
        !this.poRequestByClientDateRange.dateFrom ||
        !this.poRequestByClientDateRange.dateTo
      ) {
        appToast.danger('Date from and/or Date to is empty')
        return false
      }
      this.isFetching = true
      axios
        .get(
          `downloadables/porequestbydaterange?clientId=${
            this.poRequestByClientDateRange.clientId
          }&dateFrom=${this.poRequestByClientDateRange.dateFrom}&dateTo=${
            this.poRequestByClientDateRange.dateTo
          }`,
          {
            responseType: 'blob'
          }
        )
        .then(response => {
          console.log(response.data)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `P.O. request report by date range ${
              this.poRequestByClientDateRange.dateFrom
            }-${this.poRequestByClientDateRange.dateTo}.pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => (this.isFetching = false))
    }
  },
  watch: {
    selectedClient() {
      if (this.selectedClient) {
        this.poRequestByClientDateRange.clientId = this.selectedClient.id
      } else {
        this.poRequestByClientDateRange.clientId = null
        this.selectedClient = 0
      }
    }
  }
}
</script>
